import React, { useContext } from 'react'

import { Spinner } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'

import ReferralRewardImage from 'assets/images/referral-reward.svg'
import Button from 'components/Button'
import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { ActionType, PageName } from 'generated/types'
import { TestIDs } from 'test/utils/testIds'
import trackEvent from 'utils/analytics/trackEvent'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { FunnelContext } from 'utils/FunnelContext'

import { ReferralInterstitialNextButtonTappedEvent } from './events'
import { Body, ButtonContainer, FlexContainer, StyledImage, Title } from './styled-components'

const ReferralReward = (props: WithFlowRouterProps) => {
  const { isBackEnabled, isDynamicFunnelEnabled, routeToPage } = useContext(FunnelContext)
  const { isLoadingRemoteStrings, getRemoteString } = useRemoteStrings()
  const onPressNextButton = () => {
    trackEvent('Button Tapped', {
      eventData: ReferralInterstitialNextButtonTappedEvent,
    })

    isDynamicFunnelEnabled
      ? routeToPage(PageName.ReferralReward, ActionType.Continue)
      : props.route({ from: FlowRoute.ReferralReward, action: 'continue' })
  }

  const mainContent = (
    <>
      <Title data-testid={TestIDs.REFERRAL_REWARD.TITLE}>
        {getRemoteString({ key: 'referral_disclosure.reward.title' })}
      </Title>
      <Body data-testid={TestIDs.REFERRAL_REWARD.BODY}>
        {getRemoteString({ key: 'referral_disclosure.reward.body' })}
      </Body>
    </>
  )
  const button = (
    <ButtonContainer>
      <Button onPress={onPressNextButton} data-testid={TestIDs.REFERRAL_REWARD.NEXT_BUTTON}>
        {getRemoteString({ key: 'referral_disclosure.reward.button' })}
      </Button>
    </ButtonContainer>
  )

  return (
    <>
      <Nav back={isDynamicFunnelEnabled ? isBackEnabled(PageName.ReferralReward) : true} />
      <Layout>
        {isLoadingRemoteStrings ? (
          <Spinner />
        ) : (
          <>
            <FlexContainer>
              <StyledImage src={ReferralRewardImage} />
              {mainContent}
              <Separator />
            </FlexContainer>
            {button}
          </>
        )}
      </Layout>
    </>
  )
}

export default withFlowRouter(ReferralReward)
